import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/solid/play.svg'
import BaseIcon from '../../BaseIcon'

const Play = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 448 512" />
}

Play.propTypes = {
	className: PropTypes.string,
}

export default Play
